export default __webpack_public_path__ + "static/media/deskphone.2332f2e9.svg";